$ = require 'jquery'
Confirm = require 'views/lib/confirm'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
track = require 'debug/track'
t = require('views/internal/teacup-with-helpers')('archive_item')
Auth = require 'db/auth'
Confirm = require 'views/lib/confirm'

template = t.renderable ({
  url,
  name,
  deleting,
  canReopen,
  reOpenText,
  canDelete,
  canLeave
}) ->
  t.p '.item-name', ->
    if url && !deleting
      t.a { href: url }, ->
        t.text name
    else
      t.span ->
        t.text name

  if deleting
    t.div '.options.quiet', ->
      t.format 'deleting'
  else
    t.div '.options', ->
      if canReopen
        t.a '.button-link.js-reopen', { href: '#' }, ->
          t.icon 'refresh'
          t.text ' '
          t.text reOpenText
      if canDelete
        t.a '.button-link.negate.js-delete', { href: '#' }, ->
          t.icon 'remove', 'delete'
      if canLeave
        t.a '.button-link.negate.js-leave', { href: '#' }, ->
          t.icon 'leave-board', 'leave'

module.exports = class ArchivedModelView extends View
  tagName: 'li'

  className: 'u-clearfix'

  events:
    'click .js-reopen': 'reopen'
    'click .js-delete': 'delete'
    'click .js-leave': 'leaveConfirm'

  initialize: ->
    @listenTo @model, 'deleting', @render
    if @model.getBoard?
      @listenTo @model.getBoard(), 'change:limits', @render

  _checkTargetCapacity: ->
    # This function doesn't handle cards,
    # but this view isn't used for cards currently
    result = true
    if @model.getBoard?
      # Check for capacity on the target board (Lists and Cards)
      result = @model.getBoard().hasCapacity(@model)

    result

  canReopen: ->
    targetHasCapacity = @_checkTargetCapacity()
    if @model.owned?
      targetHasCapacity && @model.owned()
    else
      targetHasCapacity && @model.editable()

  canDelete: ->
    @model.owned?()

  canLeave: ->
    @model.owned? && !@model.owned()

  render: ->
    @$el.html template({
      name: @model.get('name')
      url: @model.getUrl?()
      reOpenText: @options.reOpenText
      canDelete: @canDelete()
      canReopen: @canReopen()
      canLeave: @canLeave()
      deleting: @model.isDeleting?()
    })

    @

  reopen: (e) ->
    Util.preventDefault(e)
    PopOver.hide()
    @model.update { closed: false }, { waitForServer: true }, =>
      track(@model.typeName, "Reopen", "Via Archive")
      @options.onReopen?(@model)
    , false

  delete: (e) ->
    Util.stop(e)

    Confirm.toggle 'delete board',
      elem: e.target
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.startDelete()
        .then =>
          track("Board", "Delete", "Via Closed Boards List")
        .done()

  leaveConfirm: (e) ->
    Util.stop(e)

    track("Closed Boards", "Open Leave Menu")

    me = Auth.me()
    key = me.removeMembershipConfirmationKey(@model)

    Confirm.toggle key,
      elem: $(e.target).closest('a')
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.removeMember(me)
        track("Board", "Leave Board", "Via Closed Boards List")

    return



// WEBPACK FOOTER //
// ./app/scripts/views/archive/archived-model-view.coffee